{
  "COMPOSE_REDIRECT": {
    "OPENING": "S'està obrint una conversa nova amb {email}…",
    "NO_EMAIL": "No s'ha proporcionat cap adreça de correu electrònic. Utilitza ?email=name@example.com",
    "CONTACT_ERROR": "No s'ha pogut trobar el contacte per a {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Si us plau, selecciona una conversa al panell de l’esquerra",
    "CSAT_REPLY_MESSAGE": "Si us plau, valoreu la conversa",
    "404": "Ho sentim, no podem trobar la conversa. Torneu-ho a provar",
    "SWITCH_VIEW_LAYOUT": "Canvia el disseny",
    "DASHBOARD_APP_TAB_MESSAGES": "Missatges",
    "UNVERIFIED_SESSION": "La identitat d'aquest usuari no està verificada",
    "NO_MESSAGE_1": "Uh oh! Sembla que no hi ha missatges de clients a la safata d'entrada.",
    "NO_MESSAGE_2": " per enviar un missatge a la vostra pàgina!",
    "NO_INBOX_1": "Hola! Sembla que encara no heu afegit cap safata d'entrada.",
    "NO_INBOX_2": " per començar",
    "NO_INBOX_AGENT": "Uh Oh! Sembla que no ets a cap safata d'entrada. Si us plau, poseu-vos en contacte amb l'administrador",
    "SEARCH_MESSAGES": "Cerca missatges a les converses",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Traducció",
    "EMPTY_STATE": {
      "CMD_BAR": "per obrir el menú d'ordres",
      "KEYBOARD_SHORTCUTS": "per veure les dreceres del teclat"
    },
    "SEARCH": {
      "TITLE": "Cerca missatges",
      "RESULT_TITLE": "Resultats de la cerca",
      "LOADING_MESSAGE": "S'estan restringint les dades...",
      "PLACEHOLDER": "Escriu qualsevol text per cercar missatges",
      "NO_MATCHING_RESULTS": "No s'han trobat resultats."
    },
    "UNREAD_MESSAGES": "Missatges no Llegits",
    "UNREAD_MESSAGE": "Missatge no Llegit",
    "CLICK_HERE": "Clica aquí",
    "LOADING_INBOXES": "S'estan carregant les safates d'entrada",
    "LOADING_CONVERSATIONS": "S'estan carregant les converses",
    "CANNOT_REPLY": "No pots respondre degut a",
    "24_HOURS_WINDOW": "Restricció de finestra de missatges de 24 hores",
    "NOT_ASSIGNED_TO_YOU": "Aquesta conversa no està assignada a tu. Vols assignar-te-la?",
    "ASSIGN_TO_ME": "Assigna'm",
    "TWILIO_WHATSAPP_CAN_REPLY": "Només pots respondre a aquesta conversa mitjançant una plantilla de missatge a causa de",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Restricció de finestra de missatges de 24 hores",
    "REPLYING_TO": "Estas responent a:",
    "REMOVE_SELECTION": "Elimina la selecció",
    "DOWNLOAD": "Descarrega",
    "UNKNOWN_FILE_TYPE": "Fitxer desconegut",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Abans d'enviar, realitzeu:",
      "EXECUTE": "Executa",
      "RETRY": "Torna-ho a provar",
      "CONFIRM": "Voleu executar-ho ara?",
      "CONFIRM_YES": "Sí, executa",
      "CONFIRM_NO": "Cancel·la",
      "RUNNING": "S'està executant…",
      "DONE": "Fet",
      "CLAIM_DELAYED": "es presentarà quan es lliuri la comanda",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "S'ha creat una reclamació NOVA {reference}, {planned} està tancada — editeu el text de l'esborrany",
        "NEW_CLAIM": "S'ha creat una reclamació NOVA {reference} en lloc d'actualitzar {planned} — editeu el text de l'esborrany",
        "OTHER_CLAIM": "S'ha actualitzat la reclamació {reference} en lloc de {planned} — editeu el text de l'esborrany",
        "EXISTING_CLAIM": "No s'ha creat cap reclamació nova, s'ha actualitzat l'existent {reference} — editeu el text de l'esborrany",
        "OTHER": "Ha anat de manera diferent de com preveia l'esborrany — editeu el text de l'esborrany"
      },
      "FAILED": "Ha fallat",
      "UNREACHABLE": "No s'ha pogut contactar amb el bot",
      "REQUEST_FAILED": "No s'ha pogut iniciar l'acció, torneu-ho a provar.",
      "ACTIONS": {
        "CANCEL_ORDER": "Cancel·lar la comanda",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Canviar el pagament a contra reemborsament",
        "CREATE_CLAIM": "Presentar una reclamació",
        "CREATE_OR_UPDATE_CLAIM": "Presentar o actualitzar una reclamació",
        "EXTEND_ORDER_PICKUP_DATE": "Ampliar el termini de recollida"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Pujant fitxers adjunts...",
    "REPLIED_TO_STORY": "Va respondre a la teva història",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Aquest missatge no està suportat. Pots veure aquest missatge a l'aplicació Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Aquest missatge no està suportat. Pots veure aquest missatge a l'aplicació d'Instagram.",
    "SUCCESS_DELETE_MESSAGE": "El missatge s'ha suprimit correctament",
    "FAIL_DELETE_MESSSAGE": "No s'ha pogut suprimir el missatge! Torna-ho a provar",
    "NO_RESPONSE": "Sense resposta",
    "RESPONSE": "Response",
    "RATING_TITLE": "Valoració",
    "FEEDBACK_TITLE": "Comentaris",
    "REPLY_MESSAGE_NOT_FOUND": "Missatge no disponible",
    "CARD": {
      "SHOW_LABELS": "Mostra etiquetes",
      "HIDE_LABELS": "Amaga etiquetes"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Resoldre",
      "REOPEN_ACTION": "Tornar a obrir",
      "OPEN_ACTION": "Obrir",
      "OPEN": "Més",
      "CLOSE": "Tanca",
      "DETAILS": "detalls",
      "SNOOZED_UNTIL": "Posposat fins a",
      "SNOOZED_UNTIL_TOMORROW": "Posposat fins demà",
      "SNOOZED_UNTIL_NEXT_WEEK": "Posposat fins a la setmana vinent",
      "SNOOZED_UNTIL_NEXT_REPLY": "Posposat fins a la següent resposta",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "perduda",
        "DUE": "límit"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Marca com a pendent",
      "SNOOZE_UNTIL": "Posposat",
      "SNOOZE": {
        "TITLE": "Posposat fins a",
        "NEXT_REPLY": "Següent resposta",
        "TOMORROW": "Demà",
        "NEXT_WEEK": "Pròxima setmana"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Posposat fins a",
      "APPLY": "Posposat",
      "CANCEL": "Cancel·la"
    },
    "PRIORITY": {
      "TITLE": "Prioritat",
      "OPTIONS": {
        "NONE": "Ningú",
        "URGENT": "Urgent",
        "HIGH": "Alta",
        "MEDIUM": "Mitjana",
        "LOW": "Baixa"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Ningú",
        "INPUT_PLACEHOLDER": "Selecciona la prioritat",
        "NO_RESULTS": "No s'ha trobat agents",
        "SUCCESSFUL": "S'ha canviat la prioritat de l'ID de conversa {conversationId} a {priority}",
        "FAILED": "No s'ha pogut canviar la prioritat. Si us plau, torna-ho a provar."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Obre en una pestanya nova",
      "COPY_LINK": "Copia l'enllaç de la conversa",
      "COPY_LINK_SUCCESS": "Enllaç de la conversa copiat al porta-retalls",
      "PENDING": "Marca com a pendent",
      "RESOLVED": "Marca com a resolt",
      "MARK_AS_UNREAD": "Marca com a no llegit",
      "MARK_AS_READ": "Marca com a llegit",
      "REOPEN": "Torna a obrir la conversa",
      "SNOOZE": {
        "TITLE": "Posposat",
        "NEXT_REPLY": "Fins a la propera resposta",
        "TOMORROW": "Fins demà",
        "NEXT_WEEK": "Fins a la setmana vinent"
      },
      "ASSIGN_AGENT": "Assigna un agent",
      "ASSIGN_LABEL": "Assigna etiqueta",
      "AGENTS_LOADING": "S'estan carregant els agents...",
      "ASSIGN_TEAM": "Assigna un equip",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Id de conversa {conversationId} assignat a \"{agentName}\"",
          "FAILED": "No s'ha pogut assignar l'agent. Torna-ho a provar."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "No s'ha pogut assignar l'etiqueta. Torna-ho a provar."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "S'ha assignat l'equip \"{team}\" a l'id de conversa {conversationId}",
          "FAILED": "No s'ha pogut assignar l'equip. Torna-ho a provar."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Signatura del missatge",
      "ENABLE_SIGN_TOOLTIP": "Activa la signatura",
      "DISABLE_SIGN_TOOLTIP": "Desactiva la signatura",
      "MSG_INPUT": "Shift + enter per a una línia nova. Comença amb '/' per seleccionar una resposta predeterminada.",
      "PRIVATE_MSG_INPUT": "Shift + enter per una línia nova. Això serà visible només per als Agents",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "La signatura del missatge no està configurada, configura-la a la configuració del perfil.",
      "CLICK_HERE": "Fes clic aquí per actualitzar",
      "WHATSAPP_TEMPLATES": "Plantilles de Whatsapp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "La finestra de 24 hores de WhatsApp ha caducat. Respon amb una plantilla.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "La teva resposta sembla que és en {draftLanguage}, però aquesta conversa és en {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Tradueix",
      "REPLY": "Respon",
      "PRIVATE_NOTE": "Nota privada",
      "SEND": "Envia",
      "CREATE": "Afegeix una nota",
      "INSERT_READ_MORE": "Llegir més",
      "DISMISS_REPLY": "Ignora la resposta",
      "REPLYING_TO": "Responent a:",
      "TIP_FORMAT_ICON": "Mostra l'editor de text enriquit",
      "HEADING_LEVEL": {
        "LABEL": "Estil del text",
        "NORMAL": "Text normal",
        "H1": "Encapçalament 1",
        "H2": "Encapçalament 2",
        "H3": "Encapçalament 3"
      },
      "EDITOR": {
        "BOLD": "Negreta",
        "ITALIC": "Cursiva",
        "UNDERLINE": "Subratllat",
        "TEXT_COLOR": "Color del text",
        "BG_COLOR_LABEL": "Color de fons",
        "FONT_SIZE_LABEL": "Mida de la lletra",
        "FONT_SIZE": {
          "XS": "Petita",
          "SM": "Mitjana petita",
          "MD": "Predeterminada",
          "LG": "Gran",
          "XL": "Molt gran",
          "XXL": "Enorme"
        },
        "CODE": "Codi",
        "LINK": "Afegeix o suprimeix l'enllaç",
        "CREATE_LINK": "Crea un enllaç",
        "SAVE_LINK": "Desa",
        "CANCEL": "Cancel·la",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Desfés",
        "REDO": "Refés",
        "BULLET_LIST": "Llista amb pics",
        "ORDERED_LIST": "Llista numerada",
        "BLOCKQUOTE": "Cita",
        "H1": "Encapçalament 1",
        "H2": "Encapçalament 2",
        "H3": "Encapçalament 3",
        "IMAGE_UPLOAD": "Puja una imatge",
        "CLEAR_FORMATTING": "Neteja el format",
        "COLOR": {
          "RED": "Vermell",
          "YELLOW": "Groc",
          "BLUE": "Blau",
          "ROSE_RED": "Vermell rosat",
          "DEEP_CYAN": "Cian fosc",
          "ORANGE": "Taronja",
          "PISTACHIO": "Festuc",
          "PURPLE": "Porpra",
          "FUCHSIA": "Fúcsia",
          "SILVER": "Plata",
          "NAVY": "Blau marí",
          "OLD_PINK": "Rosa vell",
          "AQUA": "Aiguamarina",
          "BROWN": "Marró",
          "OLIVE": "Oliva",
          "GOLD": "Daurat",
          "BEIGE": "Beix",
          "WINE": "Vi negre",
          "FOREST": "Verd bosc",
          "GREEN": "Verd",
          "BLUE_GREY": "Gris blavós",
          "RUBY_RED": "Vermell robí",
          "CHESTNUT_BROWN": "Marró castany",
          "ASH_GREY": "Gris cendra"
        },
        "BG_COLOR": {
          "RED": "Vermell",
          "YELLOW": "Groc",
          "BLUE": "Blau",
          "ROSE_RED": "Vermell rosat",
          "DEEP_CYAN": "Cian fosc",
          "ORANGE": "Taronja",
          "PISTACHIO": "Festuc",
          "PURPLE": "Porpra",
          "FUCHSIA": "Fúcsia",
          "SILVER": "Plata",
          "NAVY": "Blau marí",
          "OLD_PINK": "Rosa vell",
          "AQUA": "Aiguamarina",
          "BROWN": "Marró",
          "OLIVE": "Oliva",
          "GOLD": "Daurat",
          "BEIGE": "Beix",
          "WINE": "Vi negre",
          "FOREST": "Verd bosc",
          "GREEN": "Verd",
          "BLUE_GREY": "Gris blavós",
          "RUBY_RED": "Vermell robí",
          "CHESTNUT_BROWN": "Marró castany",
          "ASH_GREY": "Gris cendra"
        }
      },
      "TIP_EMOJI_ICON": "Mostra la selecció d'emoticones",
      "TIP_ATTACH_ICON": "Ajuntar fitxers",
      "TIP_AUDIORECORDER_ICON": "Gravar àudio",
      "TIP_AUDIORECORDER_PERMISSION": "Permet l'accés a l'àudio",
      "TIP_AUDIORECORDER_ERROR": "No s'ha pogut obrir l'àudio",
      "DRAG_DROP": "Arrossega i deixa anar aquí per adjuntar-lo",
      "START_AUDIO_RECORDING": "Inicia la gravació d'àudio",
      "STOP_AUDIO_RECORDING": "Atura la gravació d'àudio",
      "": "",
      "EMAIL_HEAD": {
        "TO": "A",
        "ADD_BCC": "Afegeix cco",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Correus electrònics separats per comes",
          "ERROR": "Introduïu adreces de correu electrònic vàlides"
        },
        "BCC": {
          "LABEL": "CCO",
          "PLACEHOLDER": "Correus electrònics separats per comes",
          "ERROR": "Introduïu adreces de correu electrònic vàlides"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Variables sense definir",
        "MESSAGE": "Tens {undefinedVariablesCount} variables sense definir al teu missatge: {undefinedVariables}. Vols enviar el missatge igualment?",
        "CONFIRM": {
          "YES": "Envia",
          "CANCEL": "Cancel·la"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Afegeix una safata d'entrada SMS per enviar respostes SMS.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Nota privada: Només és visible per tu i el vostre equip",
    "CHANGE_STATUS": "Estat de la conversa canviat",
    "CHANGE_STATUS_FAILED": "No s'ha pogut canviar l'estat de la conversa",
    "CHANGE_AGENT": "Assignació de la conversa canviat",
    "CHANGE_AGENT_FAILED": "El canvi de l'assignat ha fallat",
    "ASSIGN_LABEL_SUCCESFUL": "L'etiqueta s'ha assignat correctament",
    "ASSIGN_LABEL_FAILED": "L'assignació d'etiquetes ha fallat",
    "CHANGE_TEAM": "L'equip de conversa ha canviat",
    "FILE_SIZE_LIMIT": "El fitxer supera el límit de {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB fitxers adjunts",
    "MESSAGE_ERROR": "No es pot enviar aquest missatge, torna-ho a provar més tard",
    "SENT_BY": "Enviat per:",
    "BOT": "Bot",
    "SEND_FAILED": "No s'ha pogut enviar el missatge! Torna-ho a provar",
    "TRY_AGAIN": "reintenta",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Seleccionar Agent",
      "REMOVE": "Suprimeix",
      "ASSIGN": "Assignar"
    },
    "CONTEXT_MENU": {
      "COPY": "Copia",
      "REPLY_TO": "Respon a aquest missatge",
      "DELETE": "Esborrar",
      "CREATE_A_CANNED_RESPONSE": "Afegir a les respostes predeterminades",
      "TRANSLATE": "Tradueix",
      "COPY_PERMALINK": "Copia l'enllaç al missatge",
      "LINK_COPIED": "URL del missatge copiat al porta-retalls",
      "DELETE_CONFIRMATION": {
        "TITLE": "Estàs segur que vols suprimir aquest missatge?",
        "MESSAGE": "No pots desfer aquesta acció",
        "DELETE": "Esborrar",
        "CANCEL": "Cancel·la"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Contacte",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "La conversa va ser marcada com resolta per {userName}",
          "CONTACT_RESOLVED": "La conversa va ser resolta per {contactName}",
          "OPEN": "La conversa es va reobrir per {userName}",
          "PENDING": "La conversa va ser marcada com pendent per {userName}",
          "SNOOZED": "{userName} ha posposat la conversa",
          "AUTO_RESOLVED": "El sistema ha marcat que la conversa s'ha resolt a causa de {duration} dies d'inactivitat",
          "SYSTEM_AUTO_OPEN": "El sistema ha reobert la conversa a causa d'un nou missatge entrant.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "El sistema ha resolt la conversa perquè el tiquet s'ha tancat a Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} ha establert la prioritat a {newPriority}",
          "UPDATED": "{userName} ha canviat la prioritat de {oldPriority} a {newPriority}",
          "REMOVED": "{userName} ha eliminat la prioritat"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} s'ha auto assignat aquesta conversa",
          "ASSIGNED": "Assignada a {assigneeName} per {userName}",
          "REMOVED": "{userName} ha tret l'assignació de la conversa"
        },
        "TEAM": {
          "ASSIGNED": "Assignada a {teamName} per {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Assignat a {assigneeName} mitjançant {teamName} per {userName}",
          "REMOVED": "Sense assignar des de {teamName} per {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} ha afegit {labels}",
          "REMOVED": "{userName} ha eliminat {labels}"
        },
        "SLA": {
          "ADDED": "{userName} ha afegit la política de SLA {slaName}",
          "REMOVED": "{userName} ha eliminat la política de SLA {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} ha silenciat la conversa",
        "UNMUTED": "{userName} ha desactivat el silenci de la conversa",
        "CONTACT_BLOCKED": "{userName} ha bloquejat el contacte",
        "CONTACT_UNBLOCKED": "{userName} ha desbloquejat el contacte",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "S'ha mogut perquè les comandes del contacte només provenen de la botiga {storeName} (darrera comanda {orderId}), el robot de la qual respon en aquesta safata.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "L'automatització s'ha omès perquè el contacte està bloquejat",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "L'automatització \"{ruleName}\" no ha pogut moure aquesta conversa de la safata d'entrada {sourceInboxName} a la safata d'entrada {targetInboxName} perquè les safates no són compatibles.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "L'automatització \"{ruleName}\" no ha pogut moure aquesta conversa de la safata d'entrada {sourceInboxName} a la safata d'entrada {targetInboxName} perquè el contacte no té adreça de correu electrònic.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "L'automatització \"{ruleName}\" no ha pogut enviar un missatge: aquesta safata d'entrada telefònica no pot enviar SMS perquè el compte no té cap safata d'entrada SMS. La regla s'ha desactivat i els administradors han rebut un correu electrònic.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "L'automatització \"{ruleName}\" no ha pogut enviar un missatge: els adjunts no es poden enviar per SMS des d'aquesta safata d'entrada. La regla s'ha desactivat i els administradors han rebut un correu electrònic.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "La macro \"{macroName}\" no ha enviat el seu missatge: aquesta safata d'entrada telefònica no pot enviar SMS perquè el compte no té cap safata d'entrada SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "La macro \"{macroName}\" no ha enviat el seu missatge: els adjunts no es poden enviar per SMS des d'aquesta safata d'entrada.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "La macro \"{macroName}\" no ha enviat el seu missatge: el bot està gestionant aquesta conversa. Obre primer la conversa.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "La macro \"{macroName}\" no ha enviat el seu missatge: aquesta safata d'entrada està marcada per suprimir-se. Mou primer la conversa a una altra safata d'entrada.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "L'automatització \"{ruleName}\" ha enviat un correu electrònic a {contactEmail} en una conversa nova [#{conversationId}]({conversationPath}) a la safata d'entrada {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "L'automatització \"{ruleName}\" ha iniciat aquesta conversa a causa de la conversa [#{conversationId}]({conversationPath}) a la safata d'entrada {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "L'automatització \"{ruleName}\" no ha pogut enviar el missatge en una conversa nova a la safata d'entrada {inboxName} perquè el contacte no té adreça de correu electrònic.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "L'automatització \"{ruleName}\" ha enviat un SMS a {contactPhone} en una conversa nova [#{conversationId}]({conversationPath}) a la safata d'entrada {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "L'automatització \"{ruleName}\" no ha pogut enviar l'SMS en una conversa nova a la safata d'entrada {inboxName} perquè el contacte no té número de telèfon.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Client"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "atesa en un altre lloc, ha sonat durant {duration}",
            "NO_ANSWER": "sense resposta, ha sonat durant {duration}",
            "REJECTED": "rebutjada, ha sonat durant {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Resolta automàticament després de {count} devolucions de trucada sense resposta",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Enregistrament de la trucada eliminat per {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Invisible per al client",
    "SENT_VIA_EMAIL": "També s'ha enviat al contacte per correu electrònic ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Aquesta safata d'entrada està marcada per suprimir-se, de manera que la resposta del client no arribaria mai. Mou la conversa a una altra safata d'entrada per respondre.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Aquest contacte té una altra conversa oberta #{id}",
      "MULTIPLE": "Aquest contacte té altres converses obertes ({count})",
      "OPEN": "Obrir",
      "SHOW": "Mostrar"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Demana al client que comparteixi el seu número de telèfon de WhatsApp",
      "PENDING_ACTION": "Sol·licitud d'informació de contacte pendent",
      "STATES": {
        "PENDING": "Esperant la informació de contacte",
        "SHARED": "Número de telèfon compartit",
        "IDENTITY_CONFLICT": "El número de telèfon necessita revisió"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Envia la transcripció de la conversa",
    "DESC": "Envia una còpia de la transcripció de la conversa a l'adreça electrònica especificada",
    "SUBMIT": "Envia",
    "CANCEL": "Cancel·la",
    "SEND_EMAIL_SUCCESS": "La transcripció del xat s'ha enviat correctament",
    "SEND_EMAIL_ERROR": "S'ha produït un error; tornau-ho a provar",
    "FORM": {
      "SEND_TO_CONTACT": "Envia la transcripció al client",
      "SEND_TO_AGENT": "Envia la transcripció a l'agent assignat",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Envia la transcripció a una altra adreça electrònica",
      "EMAIL": {
        "PLACEHOLDER": "Introdueix una adreça de correu electrònic",
        "ERROR": "Introduïu una adreça de correu electrònic vàlida"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hola 👋, Benvingut a {installationName}!",
    "DESCRIPTION": "Gràcies per registrar-te. Volem que treguis el màxim profit de {installationName}. Aquí teniu algunes coses que pots fer a {installationName} perquè l'experiència sigui agradable.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Llegiu les nostres últimes actualitzacions",
    "ALL_CONVERSATION": {
      "TITLE": "Totes les teves converses en un sol lloc",
      "DESCRIPTION": "Consulta totes les converses dels teus clients en un únic tauler. Podeu filtrar les converses pel canal d'entrada, l'etiqueta i l'estat.",
      "NEW_LINK": "Fes clic aquí per crear una safata d'entrada"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Convida els membres del teu equip",
      "DESCRIPTION": "Com que us esteu preparant per parlar amb el vostre client, feu venir els vostres companys d'equip per ajudar-vos. Pots convidar els teus companys d'equip afegint les seves adreces de correu electrònic a la llista d'agents.",
      "NEW_LINK": "Feu clic aquí per convidar un membre de l'equip"
    },
    "LABELS": {
      "TITLE": "Organitza converses amb etiquetes",
      "DESCRIPTION": "Les etiquetes proporcionen una manera més fàcil de classificar la vostra conversa. Crea algunes etiquetes com #consulta-suport, #pregunta-facturació, etc., perquè les puguis utilitzar en una conversa més endavant.",
      "NEW_LINK": "Fes clic aquí per crear etiquetes"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Agent assignat",
    "SELF_ASSIGN": "Assigna-me-la",
    "TEAM_LABEL": "Assignada a un equip",
    "SELECT": {
      "PLACEHOLDER": "Ningú"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Detalls de contacte",
      "CONVERSATION_ACTIONS": "Accions de conversa",
      "CONVERSATION_LABELS": "Etiquetes de converses",
      "CONVERSATION_INFO": "Informació de la conversa",
      "CONTACT_ATTRIBUTES": "Atributs de contacte",
      "PREVIOUS_CONVERSATION": "Converses prèvies",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Pendent",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Crea atribut",
    "NO_RECORDS_FOUND": "No s'han trobat atributs",
    "UPDATE": {
      "SUCCESS": "Atribut actualitzat correctament",
      "ERROR": "No es pot actualitzar l'atribut. Si us plau, intenta-ho més tard"
    },
    "ADD": {
      "TITLE": "Afegir",
      "SUCCESS": "Atribut afegit correctament",
      "ERROR": "No es pot afegir l'atribut. Si us plau, intenta-ho més tard"
    },
    "DELETE": {
      "SUCCESS": "Atribut esborrat correctament",
      "ERROR": "No es pot esborrar l'atribut. Si us plau, intenta-ho més tard"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Afegir atributs",
      "PLACEHOLDER": "Cerca atributs",
      "NO_RESULT": "No s'han trobat atributs"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Des de",
    "TO": "Per",
    "BCC": "Cco",
    "CC": "Cc",
    "SUBJECT": "Assumpte"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participant",
    "SIDEBAR_TITLE": "Participants de la conversa",
    "NO_RECORDS_FOUND": "No s'ha trobat agents",
    "ADD_PARTICIPANTS": "Selecciona els participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} més",
    "REMANING_PARTICIPANT_TEXT": "+{count} més",
    "TOTAL_PARTICIPANTS_TEXT": "{count} persones estan participant.",
    "TOTAL_PARTICIPANT_TEXT": "{count} persona està participant.",
    "NO_PARTICIPANTS_TEXT": "No hi participa ningú!",
    "WATCH_CONVERSATION": "Uneix-te a la conversa",
    "YOU_ARE_WATCHING": "Estàs participant",
    "API": {
      "ERROR_MESSAGE": "No s'ha pogut actualitzar, torna-ho a provar!",
      "SUCCESS_MESSAGE": "Participants actualitzats!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Veure contingut traduït",
    "DESC": "Pots veure el contingut traduït a cada idioma.",
    "ORIGINAL_CONTENT": "Contingut original",
    "TRANSLATED_CONTENT": "Contingut traduït",
    "NO_TRANSLATIONS_AVAILABLE": "No hi ha traduccions disponibles per a aquest contingut"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Número de comanda",
    "EXTERNAL_ID": "ID extern",
    "PAYMENT_TYPE": "Mètode de pagament",
    "PAYMENT_DATE": "Data de pagament",
    "DELIVERY_PROVIDER": "Transportista",
    "EXPECTED_DATE_OF_DELIVERY": "Lliurament previst",
    "DATE_OF_DELIVERY": "Lliurat el",
    "EXPEDITION_DATE": "Data d'expedició",
    "INTERNAL_NOTE": "Nota de la botiga",
    "PACKAGE_NUMBER": "Paquet"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
